import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useAppDispatch } from '../../../../hooks';
import { CmdArea } from '../../common/CmdArea';
import { String } from '../../common/String';
import { Number } from '../../common/Number';
import { zigbeeLockDoor } from '../../../../actions/zigbee/commands/DoorLock/ZigbeeLockDoor';
import { zigbeeUnlockDoor } from '../../../../actions/zigbee/commands/DoorLock/ZigbeeUnlockDoor';
import { zigbeeGetPinCode } from '../../../../actions/zigbee/commands/DoorLock/ZigbeeGetPinCode';
import { zigbeeGetUserStatus } from '../../../../actions/zigbee/commands/DoorLock/ZigbeeGetUserStatus';
import { zigbeeGetUserType } from '../../../../actions/zigbee/commands/DoorLock/ZigbeeGetUserType';
import { zigbeeGetLogRecord } from '../../../../actions/zigbee/commands/DoorLock/ZigbeeGetLogRecord';
import { zigbeeSetPinCode } from '../../../../actions/zigbee/commands/DoorLock/ZigbeeSetPinCode';
import { zigbeeClearPinCode } from '../../../../actions/zigbee/commands/DoorLock/ZigbeeClearPinCode';
const CmdLockDoor = (props) => {
    const [code, setCode] = useState('');
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeLockDoor(props.nid, props.eid, { code }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Code ", _jsx(String, { value: code, setValue: setCode })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Lock" })] }));
};
const CmdUnlockDoor = (props) => {
    const [code, setCode] = useState('');
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeUnlockDoor(props.nid, props.eid, { code }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Code ", _jsx(String, { value: code, setValue: setCode })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Unlock" })] }));
};
const CmdGetLogRecord = (props) => {
    const [logIndex, setLogIndex] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeGetLogRecord(props.nid, props.eid, { logIndex }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["User ID ", _jsx(Number, { value: logIndex, setValue: setLogIndex })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "GetLogRecord" })] }));
};
const CmdSetPinCode = (props) => {
    const [userID, setUserID] = useState(0);
    const [code, setCode] = useState('');
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeSetPinCode(props.nid, props.eid, { userID, code }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["User ID ", _jsx(Number, { value: userID, setValue: setUserID })] }), _jsx("br", {}), _jsxs("label", { children: ["Code ", _jsx(String, { value: code, setValue: setCode })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "SetPinCode" })] }));
};
const CmdGetPinCode = (props) => {
    const [userID, setUserID] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeGetPinCode(props.nid, props.eid, { userID }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["User ID ", _jsx(Number, { value: userID, setValue: setUserID })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "GetPinCode" })] }));
};
const CmdClearPinCode = (props) => {
    const [userID, setUserID] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeClearPinCode(props.nid, props.eid, { userID }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["User ID ", _jsx(Number, { value: userID, setValue: setUserID })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "ClearPinCode" })] }));
};
const CmdGetUserStatus = (props) => {
    const [userID, setUserID] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeGetUserStatus(props.nid, props.eid, { userID }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["User ID ", _jsx(Number, { value: userID, setValue: setUserID })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "GetUserStatus" })] }));
};
const CmdGetUserType = (props) => {
    const [userID, setUserID] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeGetUserType(props.nid, props.eid, { userID }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["User ID ", _jsx(Number, { value: userID, setValue: setUserID })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "GetUserType" })] }));
};
export const CommandsDoorLock = props => {
    return (_jsx(React.Fragment, { children: _jsxs("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '1em' }, children: [_jsx(CmdLockDoor, Object.assign({}, props)), _jsx(CmdUnlockDoor, Object.assign({}, props)), _jsx(CmdGetLogRecord, Object.assign({}, props)), _jsx(CmdSetPinCode, Object.assign({}, props)), _jsx(CmdGetPinCode, Object.assign({}, props)), _jsx(CmdClearPinCode, Object.assign({}, props)), _jsx(CmdGetUserStatus, Object.assign({}, props)), _jsx(CmdGetUserType, Object.assign({}, props))] }) }));
};
